export default class Calendar {
  sortCalendars(arr, propertyName) {
    const sortedArr = arr.sort((a, b) => {
      if (a[propertyName] < b[propertyName]) {
        return -1;
      }
      if (a[propertyName] > b[propertyName]) {
        return 1;
      }
      return 0;
    });
    return sortedArr;
  }
}
